import { Component, Injector, OnInit } from '@angular/core';
import { AppConfiguration } from 'src/app/app-configuration';
import { ARTIFACT_KEY } from 'src/app/core/constants/artifacts-order.constants';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { ArtifactBaseComponent } from '../artifact-base-component';
import { UploadService } from 'src/app/core/services/upload.service';
import { from, mergeMap } from 'rxjs';
import { ARTIFACT_STATUS, ARTIFACT_SUBMMITED_BY } from 'src/app/core/enums/artifact.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-appfee',
  templateUrl: './appfee.component.html',
  styleUrls: ['./appfee.component.scss']
})
export class AppfeeComponent extends ArtifactBaseComponent implements OnInit {

  ARTIFACT_KEY = ARTIFACT_KEY;
  ARTIFACT_STATUS = ARTIFACT_STATUS;
  documents:any[] = [];
  constructor(
    private injector: Injector,
    public appConfig: AppConfiguration,
    public override appWizService : AppWizService,
    public override uploadService : UploadService,
    private router: Router,
  ) {
    super(injector)
  }

  initJsonData(){ }
  validateJsonData(){ }
  resetJsonData(){ }


  feeSummary(){
    let feeSummaryId = this.artifact.feeSummaryId;
    return this.appWizService.appWizard.feeSummaries.find((i:any)=>i.feeSummaryId == feeSummaryId)
  }
  paymentRoute() {
    this.router.navigate(['/app/payment'], { 
      queryParams: { 
        appId: this.artifact.appId,
        feeSummaryId: this.artifact.feeSummaryId,
      }
    });
  }
}
